import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/ArticleContent.module.scss';
import Link from 'next/link';
import { ArticleBlockModel } from '../../../../services/content/articleBody/models/ArticleBlockModel';
import { ArticleModel } from '../../../../services/content/article/models/ArticleModel';
import { getMainMediaImageByCropRatio } from '../../../../services/content/image/ImageConfiguration';
import { ImageRatios, ImageSizes } from '../../../../services/content/image/models/ImageModel';
import { Routes } from '../../../../constants/Routes';
import { CategoryText } from '../../../Partials/Category/CategoryText';
import { mergeAuthorsWithCustomAuthor } from '../../../../services/content/author/Author';
import { hasAuthors } from '../../../../constants/GlobalHelpers';
import S365Picture from '../../../Image/S365Picture';

type Props = {
    articleBlock: ArticleBlockModel;
};

export const ArticleBlock: FunctionComponent<Props> = ({ articleBlock }) => {
    const blockContent: ArticleModel = articleBlock.data.content;
    // NOTE: need smaller image
    const image: string = getMainMediaImageByCropRatio(blockContent.mainMedia, ImageRatios.RATIO_4X3, ImageSizes.SMALL);
    const authors = articleBlock.data.content.authors;
    const customAuthor = articleBlock.data.content.customAuthor;
    if (blockContent && blockContent.id) {
        return (
            <div className={`${styles.articleBlock} pb-4 pt-4`}>
                <Link className={`d-flex flex-column flex-md-row`} href={Routes.openArticle(blockContent.id)}>
                    <S365Picture
                        url={image}
                        alt={blockContent.title}
                        className={`normalize-nextjs-image mb-1 me-md-4`}
                    />
                    <div className='d-flex flex-column justify-content-between'>
                        <div className='d-flex flex-column justify-content-center justify-content-md-start'>
                            <CategoryText className='text-center text-md-start mb-md-4'>
                                {blockContent.category?.title.toUpperCase()}
                            </CategoryText>
                            <div className='text-center text-md-start mb-2 d-md-none'>
                                Автор {blockContent.authors ? blockContent?.authors[0]?.name : ''}
                            </div>
                            <h2 className='text-center text-md-start'>{blockContent.title}</h2>
                        </div>
                        {hasAuthors(authors, customAuthor) && (
                            <div className='d-none d-md-block'>
                                Автор {mergeAuthorsWithCustomAuthor(authors, customAuthor)}
                            </div>
                        )}
                    </div>
                </Link>
            </div>
        );
    }

    return null;
};
